import { Font, StyleSheet } from '@react-pdf/renderer';
import RobotoRegular from '../../assets/fonts/Roboto-Regular.ttf';
import RobotoBold from '../../assets/fonts/Roboto-Bold.ttf';

Font.register({
  family: 'Roboto',
  fonts: [{ src: RobotoRegular }, { src: RobotoBold, fontWeight: 700 }],
});

const styles = StyleSheet.create({
  viewer: {
    position: 'absolute',
    border: 0,
    height: '100%',
    width: '100%',
  },
  page: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Roboto',
    fontSize: 12,
    paddingVertical: 24,
    paddingHorizontal: 24,
    flex: 1,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  logo: {
    width: 154,
    height: 52,
  },
  osInfoHeader: {
    display: 'flex',
    flexDirection: 'column',
    borderWidth: 1,
    borderColor: '#c4c4c4',
    borderStyle: 'solid',
    borderRadius: 4,
    paddingHorizontal: 14,
    paddingVertical: 8,
  },
  osInfoGroupInputs: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  osInfoContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    fontSize: 12,
  },
  osInfoLabel: {
    color: '#222',
    fontSize: 12,
    fontWeight: 700,
    marginRight: 10,
  },
  assitanceInfoLabel: {
    color: '#222',
    fontSize: 14,
    paddingLeft: 10,
    fontWeight: 700,
    marginRight: 10,
  },
  qrcode: { height: 112, width: 112 },
  clientInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingVertical: 10,
  },
  sectionGroup: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  section: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    border: 1,
    borderStyle: 'solid',
    borderColor: '#c4c4c4',
    borderRadius: 4,
    padding: '18 18 8 18',
    marginVertical: 10,
  },
  osInfoSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontSize: 12,
    marginBottom: 5,
  },
  osInfoSectionLabel: {
    color: '#222',
    fontSize: 12,
    fontWeight: 700,
    marginRight: 10,
  },
  sectionTitleBackground: {
    backgroundColor: '#fff',
    position: 'absolute',
    top: -9,
    left: 10,
    paddingHorizontal: 5,
  },
  sectionTitle: {
    fontSize: 14,
    color: '#c4c4c4',
    fontWeight: 700,
  },
  tableHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingBottom: 5,
    marginBottom: 5,
    borderBottomWidth: 1,
    borderColor: '#ddd',
  },
  th: {
    fontWeight: 700,
    width: '14.2%',
    textAlign: 'center',
  },
  thLeft: {
    textAlign: 'left',
    fontWeight: 700,
    width: '14.2%',
  },
  tableBody: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 5,
  },
  td: {
    textAlign: 'center',
    width: '14.2%',
  },
  tdLeft: {
    textAlign: 'left',
    width: '14.2%',
  },
  icon: {
    width: 8,
    height: 8,
  },
  osInfoServiceLabel: {
    color: '#222',
    fontSize: 12,
    marginRight: 10,
  },
  sectionPrism: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  prismContainerTitle: {
    color: '#222',
    marginBottom: 5,
  },
  prismContainerEye: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    marginBottom: 5,
  },
  prismContainerEyeInfo: { display: 'flex', flexDirection: 'row' },
});

export default styles;
